import { FC, Fragment, useEffect } from 'react';
import HomeDesktop from './HomeDesktop/HomeDesktop';
import HomeMobile from './HomeMobile/HomeMobile';
import { isMobile } from 'utils/isMobile';
import Tap from '@tapfiliate/tapfiliate-js';
import useLocalStorageState from 'use-local-storage-state';
import useScrollTop from 'app/hooks/useScrollTop';
import { Helmet } from 'react-helmet';
interface Result {
  id: string;
  vid: string;
}

const Home: FC = () => {
  useScrollTop(true);
  const [, setTapfiliateVid] = useLocalStorageState('tapVid');

  const detectOptions = {
    always_callback: true,
  };

  const callback = (error: unknown, result: Result) => {
    if (result) {
      setTapfiliateVid(result.vid || result.id);
    }
  };

  useEffect(() => {
    Tap.detect(detectOptions, callback);
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>
          Stroller Rentals in Orlando | Strollers to your Orlando Resort
        </title>
        <meta
          name="description"
          content="Premium stroller and crib rentals for Disney vacations. Most recommended stroller rental company in Orlando."
        />
      </Helmet>
      {isMobile ? <HomeMobile /> : <HomeDesktop />}
    </Fragment>
  );
};

export default Home;
